"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const DueDateAuditTooltip = ({ dueDateFieldName, currentDate, extensionDates, ...props }) => {
    const classes = core_1.makeStyles((theme) => ({
        arrow: {
            color: theme.palette.common.black,
        },
        tooltip: {
            backgroundColor: theme.palette.common.black,
        },
    }));
    return (react_1.default.createElement(core_1.Tooltip, Object.assign({ arrow: true, classes: classes(), title: react_1.default.createElement(core_1.Box, { p: 1 },
            react_1.default.createElement("strong", { color: "inherit" },
                dueDateFieldName,
                "s period extended"),
            react_1.default.createElement(core_1.Box, { style: { paddingTop: '4px' } },
                "Extension: ",
                moment_1.default.unix(currentDate).format('LL'),
                react_1.default.createElement("br", null),
                "Original: ",
                moment_1.default.unix(extensionDates[extensionDates.length - 1].fieldValue).format('LL'))) }, props)));
};
DueDateAuditTooltip.propTypes = {
    dueDateFieldName: prop_types_1.default.string.isRequired,
    currentDate: prop_types_1.default.any.isRequired,
    extensionDates: prop_types_1.default.array.isRequired,
};
exports.default = DueDateAuditTooltip;
